import {
  Tabs,
} from "antd";
import React, {
  forwardRef,
  useState,
} from "react";
import './index.scss'
import OperatingStatementAnalysis from "@/views/Dashboard/OperatingStatementAnalysis";
import OperaStatement from "@/views/Dashboard/OperaStatement";

const MainTable = forwardRef((props, ref) => {
  const [tabsKey, setTabsKey] = useState(1);

  return (
    <div className="OperatingStatementAnalysisBox">
      <Tabs 
        activeKey={tabsKey}
        forceRender
        items={[
          {key: 1, label: "Operating Statement", children: <OperaStatement />},
          {key: 2, label: "Operating Statement Analysis", children: <OperatingStatementAnalysis />},
        ]}
        onChange={key => setTabsKey(key)}
      />
    </div>
  );
});
export default MainTable;